module.exports = __webpack_public_path__ + "img/napravlen-mobile-21.1e7a1505.jpg";